import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const BellWithNotificationOutline = createIcon({
  displayName: 'BellWithNotificationOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24v-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M17.436 6c1.381 0 2.5 1.119 2.5 2.5 0 1.381-1.119 2.5-2.5 2.5 -1.381 0-2.5-1.119-2.5-2.5 0-1.381 1.12-2.5 2.5-2.5"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.736 6.676c-.778-.628-1.754-1.019-2.831-1.019h.002 -1.813c-2.502 0-4.531 2.028-4.531 4.531v0 2.797c0 .53-.211 1.039-.586 1.414l-.641.641c-.375.375-.586.884-.586 1.414v0c0 1.044.846 1.89 1.89 1.89h10.721c1.044 0 1.89-.846 1.89-1.89v0c0-.53-.211-1.039-.586-1.414l-.641-.641c-.375-.375-.586-.884-.586-1.414v-1.986"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9.708 18.344v.365c0 1.265 1.026 2.291 2.292 2.291v0c1.266 0 2.292-1.026 2.292-2.292v-.365"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.833 5.751v-.918c0-1.012-.82-1.833-1.833-1.833v0c-1.013 0-1.833.821-1.833 1.833v.918"
        ></path>
      </g>
    </>
  ),
})

const BellWithNotificationTwoTone = createIcon({
  displayName: 'BellWithNotificationTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box as="g" fill="none">
        <Box
          as="path"
          fill="light"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M15.736 6.676c-.778-.628-1.754-1.019-2.831-1.019h.002 -1.813c-2.502 0-4.531 2.028-4.531 4.531v0 2.797c0 .53-.211 1.039-.586 1.414l-.641.641c-.375.375-.586.884-.586 1.414v0c0 1.044.846 1.89 1.89 1.89h10.721c1.044 0 1.89-.846 1.89-1.89v0c0-.53-.211-1.039-.586-1.414l-.641-.641c-.375-.375-.586-.884-.586-1.414v-1.986"
        ></Box>
        <Box
          as="path"
          fill="twoToneLightColor"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M17.436 6c1.381 0 2.5 1.119 2.5 2.5 0 1.381-1.119 2.5-2.5 2.5 -1.381 0-2.5-1.119-2.5-2.5 0-1.381 1.12-2.5 2.5-2.5"
        ></Box>

        <Box
          as="path"
          fill="light"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9.708 18.344v.365c0 1.265 1.026 2.291 2.292 2.291v0c1.266 0 2.292-1.026 2.292-2.292v-.365"
        ></Box>
        <Box
          as="path"
          fill="twoToneFillColor"
          stroke="twoToneStrokeColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M13.833 5.751v-.918c0-1.012-.82-1.833-1.833-1.833v0c-1.013 0-1.833.821-1.833 1.833v.918"
        ></Box>
      </Box>
    </>
  ),
})

const BellWithNotification: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={BellWithNotificationTwoTone} {...props} />
  return <CustomIcon as={BellWithNotificationOutline} {...props} />
}

export default memo(BellWithNotification)
